import ConfigRoutes from "../../config/Routes"

import SessionsNew from "../../common/controllers/devise/SessionsNew";
import PasswordNew from "../../common/controllers/devise/PasswordNew";
import PasswordEdit from "../../common/controllers/devise/PasswordEdit";

import StudentsShow from "../controllers/StudentsShow";
import PlanningIndex from "../controllers/PlanningIndex";
import AdministrativeFilesIndex from "../controllers/AdministrativeFilesIndex";
import ContactTeamIndex from "../controllers/ContactTeamIndex";
import StudentsIndex from "../controllers/StudentsIndex";
import DrivingTestsResults from "../controllers/DrivingTestsResults";
import BookletSkills from "../controllers/BookletSkills";
import BookletIndex from "../controllers/BookletIndex";
import BookletComments from "../controllers/BookletComments";
import PracticeExamsShow from "../controllers/PracticeExamsShow";
import BookletAffi from "../controllers/BookletAffi";
import BookletAffiSignature from "../controllers/BookletAffiSignature";
import ContactForm from "../controllers/ContactForm";


export default class Routes extends ConfigRoutes{

    static routes = {
        "DrivingInstructorsSessionsNew": SessionsNew,
        "DrivingInstructorsSessionsCreate": SessionsNew,
        "DeviseSessionsNew": SessionsNew,
        "DrivingInstructorsPasswordsNew": PasswordNew,
        "DrivingInstructorsPasswordsCreate": PasswordNew,
        "DrivingInstructorsPasswordsEdit": PasswordEdit,
        "DrivingInstructorsPasswordsUpdate": PasswordEdit,

        "MonitorsStudentsShow": StudentsShow,
        "MonitorsPlanningIndex": PlanningIndex,
        "MonitorsAdministrativeFilesIndex": AdministrativeFilesIndex,
        "MonitorsAdministrativeFilesUpdate": AdministrativeFilesIndex,
        "MonitorsAdministrativeFilesUpdatePassword": AdministrativeFilesIndex,
        "MonitorsContactTeamIndex": ContactTeamIndex,
        "MonitorsStudentsIndex": StudentsIndex,
        "MonitorsDrivingTestsResults": DrivingTestsResults,
        "MonitorsBookletSkills": BookletSkills,
        "MonitorsBookletIndex": BookletIndex,
        "MonitorsBookletObservations": BookletComments,
        "MonitorsPracticeExamsShow": PracticeExamsShow,
        "MonitorsBookletAffi": BookletAffi,
        "MonitorsBookletShowSignatureAffi": BookletAffiSignature,
        "MonitorsContactTeamIndex": ContactForm,
    };

    constructor() {
        super();
        this.routes = Object.assign(this.routes, Routes.routes);
    }
}